<script>

    export default {

        data: function () {

            return {
                active: false,
                active_done: false,
                clients: [],
                client: null,
                dataFrm: null,
                confirmInfo: null,
                permalink: null,
                loading: false,
                logged_in_client: null,
                isWaitingList: false,
            }

        },

        mounted: function () {
            let vm = this;

            this.$event_bus.$on('LoadData', (data) => {
                this.permalink = data.permalink;
                this.logged_in_client = data.logged_in_client;
            });

            this.$event_bus.$on('chooseUser', (data) => {
                this.active = true;
                if ($(window).width() < 500) {
                    setTimeout(function(){
                        $('html, body').animate({scrollTop:$('#fill-information-panel').offset().top});
                    }, 250);
                };

                this.dataFrm = data.dataFrm;
                this.confirmInfo = data.confirmInfo;
                this.clients = data.clients;
                this.isWaitingList = data.waitingListSelected;

                this.$nextTick(function () {
                    $('#collapseClients').collapse('show');
                });
            });

            this.$event_bus.$on('booking-restart', () => {
                this.active = false;
                this.active_done = false;
            });

            this.$event_bus.$on('CalendarsShowed', () => {
                this.active = false;
                this.active_done = false;
            });

            this.$event_bus.$on('ProductsShowed', () => {
                this.active = false;
                this.active_done = false;
            });

            this.$event_bus.$on('AddonProductsShowed', () => {
                this.active = false;
                this.active_done = false;
            });

            this.$event_bus.$on('TimesShowed', () => {
                this.active = false;
                this.active_done = false;
            });

            this.$event_bus.$on('FillInfoShowed', () => {
                this.active = false;
                this.active_done = false;
            });

            $('#collapseClients').on('show.bs.collapse', function () {
                vm.$event_bus.$emit('ClientsShowed');
            });

        },

        methods: {

            clientClicked(client) {
                this.active_done = true;
                this.loading = true;

                this.client = client;
                if (client.id == 'new') {
                    this.client.name = this.logged_in_client ? this.logged_in_client.name : this.confirmInfo.name;
                }

                this.dataFrm.append('client', client.id);
                this.$event_bus.$emit('confirm', {dataFrm: this.dataFrm, confirmInfo: this.confirmInfo});
            }

        },
    };


</script>


<template id="choose-user">

    <div class="panel" id="choose-user-panel" v-if="active">

        <a class="panel-title" data-toggle="collapse" href="#collapseClients"
                      role="button" aria-expanded="false" aria-controls="collapseClients" :class="{'disable-link' : active, 'enable-link' : active_done }" @click="active_done = false">
            <div class="panel-heading-small bg-green" :class="{'bg-green-done' : active_done }" role="tab" id="headingClients">
                <i class="zmdi zmdi-accounts m-r-5"></i>
                <span v-if="!client && !isWaitingList">{{ trans('online_booking.choose_client_title') }}</span>
                <span v-if="!client && isWaitingList">{{ trans('waiting_list.choose_client_title') }}</span>
                <span v-if="client">{{ client.name }}</span>
            </div>
        </a>

        <div id="collapseClients" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingClients" data-parent="#booking-accordion">

            <div class="panel-body" id="choose-user-body-booking">

                <div class="row">

                    <div class="col-xs-12">

                        <ep-banner>
                            <span class="m-b-5" v-if="!isWaitingList">
                                {{ trans('online_booking.choose_client_booking_description_1') }}
                                <br/>
                                <strong class="alert-indent">{{ trans('online_booking.choose_client_booking_description_2') }}</strong>
                            </span>
                            <span class="m-b-5" v-else>
                                {{ trans('waiting_list.choose_client_waiting_list_description_1') }}
                                <br>
                                <strong class="alert-indent">{{ trans('waiting_list.choose_client_waiting_list_description_2') }}</strong>
                            </span>
                        </ep-banner>

                        <div class="row">

                            <div class="col-sm-6 col-lg-4 m-b-15" v-for="client in clients">
                                <button class="btn btn-default btn-block" @click="clientClicked(client)">
                                    <i class="zmdi zmdi-account m-r-10 alert-ico"></i>{{ client.name }}
                                </button>
                            </div>
                            <div class="col-sm-6 col-lg-4 m-b-15">
                                <button class="btn btn-primary btn-block" @click="clientClicked({id: 'new'})">
                                    <i class="zmdi zmdi-account-add m-r-10 alert-ico"></i>
                                    {{ trans('online_payment.as_new_client') }}
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
